export default "__VITE_ASSET__CwvzuqRp__"